import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  appearance: none;\n  width: 100%;\n  height: 4px;\n  background-color: white;\n\n  /* IE's progress bar is really...progressive \uD83D\uDE0F */\n  &::-webkit-progress-bar {\n    background-color: white;\n  }\n\n  &::-moz-progress-bar {\n    background-color: white;\n  }\n\n  &::-webkit-progress-value {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, defaultProps, withProps } from 'recompose';
import styled from '../../utils/styling/styled-components';
import { PROGRESS_BAR } from '../../utils/testing/TestIDs';
var enhance = compose(defaultProps({
  max: 100,
  value: 0
}), withProps(function (_ref) {
  var value = _ref.value;
  return {
    value: Math.round(value)
  };
}));
var StyledProgressBar = styled.progress(_templateObject(), function (props) {
  return props.theme.gradients.green[1];
});

var getProgressBar = function getProgressBar(_ref2) {
  var max = _ref2.max,
      value = _ref2.value,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(StyledProgressBar, {
    "data-testid": PROGRESS_BAR,
    max: max,
    value: value,
    className: className
  });
};

var MinimalProgressBar = enhance(function (props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, getProgressBar(props));
});
export { MinimalProgressBar };